<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading"
    class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p>Centre Target</p>
</div>

<div *ngIf="!isLoading"
    style="container: daily-target / inline-size;" class="w-full min-w-0 px-4 sm:px-10 py-7 bg-tileLight shadow-lg rounded-lg dark:text-[#FFFFFF] dark:bg-[#363636]">
    <div class="flex flex-row flex-wrap gap-6">
        <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer"
            [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectPrograss}" (click)="selectPrograss()">
            <i *ngIf="isSelectPrograss" class="fa-solid fa-check"></i>
            <p>Progress</p>
        </div>

        <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer"
            [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectAssign}" (click)="selectAssign()">
            <i *ngIf="isSelectAssign" class="fa-solid fa-check"></i>
            <p>Assign</p>
        </div>
    </div>

    <hr class="my-8 border-[1px] border-[black]" />


    <div *ngIf="isSelectPrograss">
        <div class="flex flex-row flex-wrap gap-6">
            <button class="bg-[#415CFF] text-white font-normal rounded-lg shadow-md px-3 py-2"
                (click)="navigate('/target/download-target')">
                Download Collection
            </button>
        </div>


        <div class="[@container_daily-target_(max-width:48rem)]:flex-wrap flex flex-nowrap items-center justify-between gap-4 mt-5">
            <div class="flex flex-col justify-between flex-[1_1_12rem] min-w-0 whitespace-normal break-words">
                <p class="font-semibold text-lg mb-1">Centre Target on {{today}} </p>
            </div>
            <div class="[@container_daily-target_(max-width:48rem)]:flex-wrap [@container_daily-target_(max-width:48rem)]:justify-start [@container_daily-target_(max-width:48rem)]:basis-full [@container_daily-target_(max-width:30rem)]:[&>div]:w-full [@container_daily-target_(max-width:30rem)]:[&>div]:max-w-full [@container_daily-target_(max-width:30rem)]:[&>div]:flex-none [@container_daily-target_(max-width:30rem)]:[&>div]:mr-0 flex flex-nowrap items-center justify-end gap-4 flex-[3_1_auto] min-w-0">
                <i class="fa-solid text-[#4A4A4A] fa-list text-lg shrink-0 dark:text-white"></i>

                <p class="text-[#4A4A4A] dark:text-white shrink-0 whitespace-nowrap">Filter By</p>

                <div class="relative w-40 max-w-full shrink-0 custom-status-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Pending">Pending</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Completed">Completed</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Exceeded">Exceeded</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Extra">Extra</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                            <span>{{ selectStatus || 'Status' }}</span>
                            <div class="flex items-center">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isStatusDropdownOpen"
                                    [class.fa-angle-up]="isStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isStatusDropdownOpen"
                        class="absolute overflow-hidden z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div class="">
                            <div *ngFor="let option of statusDropdownOptions; let i = index;"
                                (click)="selectStatusOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === statusDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="[@container_daily-target_(max-width:48rem)]:basis-48 [@container_daily-target_(max-width:48rem)]:min-w-48 flex items-center rounded-full px-4 py-2 w-96 max-w-96 min-w-0 flex-[1_1_10rem] bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop / Variety Name" [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (keyup.esc)="offSearch()" (input)="checkLeadingSpace()"
                        class="bg-transparent outline-none flex-1 min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="hasData"
            class="w-full min-w-0 overflow-x-auto mt-8 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
            <table class="w-full min-w-max divide-y-2 overflow-hidden">
                <thead class=" text-[#4B5563] dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class="px-6 py-3 text-[#4B5563] text-left font-medium">No</th>
                        <th class="px-6 py-3 text-[#4B5563] text-left font-medium">Crop Name</th>
                        <th class="px-6 py-3 text-[#4B5563] text-left font-medium">Variety Name</th>
                        <th class="px-6 py-3 text-[#4B5563] text-center font-medium">Grade</th>
                        <th class="px-6 py-3 text-[#4B5563] text-left font-medium">Target (kg)</th>
                        <th class="px-6 py-3 text-[#4B5563] text-left font-medium">Completed (kg)</th>
                        <th class="px-6 py-3 text-[#4B5563] text-center font-medium">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <!-- <tr *ngFor="let item of targetArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index"> -->
                    <tr *ngFor="let item of targetArr; let i = index">
                        <!--  -->
                        <td class="px-6 py-4 text-[#000000] font-[500] dark:text-gray-300">
                            {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }} </td>
                        <td class="px-6 py-4 text-[#000000] font-[500] dark:text-gray-300">{{item.cropNameEnglish}}</td>
                        <td class="px-6 py-4 text-[#000000] font-[500] dark:text-gray-300">{{item.varietyNameEnglish}}
                        </td>
                        <td class="px-6 py-4 text-[#000000] font-[500] text-center  dark:text-gray-300">{{item.grade}}
                        </td>
                        <td class="px-6 py-4 text-[#000000] font-[500] dark:text-gray-300">
                            {{ item.target === 0.00 ? 'Not Set' : item.target }}
                        </td>
                        <td class="px-6 py-4 text-left text-[#000000] font-[500] dark:text-gray-300">
                            {{ item.complete === 0.00 ? 'Empty' : item.complete }}
                        </td>

                        <td class="px-6 py-4 text-[#000000] font-[500] dark:text-gray-300">
                            <div class="flex justify-center">
                                <span *ngIf="item.status === 'Pending'"
                                    class="bg-[#F8FFA6] text-[#A8A100] text-center rounded-lg px-8 py-1 h-full flex items-center">
                                    Pending
                                </span>
                                <span *ngIf="item.status === 'Exceeded'"
                                    class="bg-[#C8E0FF] text-[#415CFF] text-center rounded-lg px-6 py-1 h-full flex items-center">
                                    Exceeded
                                </span>
                                <span *ngIf="item.status === 'Completed'"
                                    class="bg-[#c0f8ac] text-[#30911a] text-center rounded-lg px-4 py-1 h-full flex items-center">
                                    Completed
                                </span>

                                <span *ngIf="item.status === 'Extra'"
                                    class="bg-[#FFE4C9] text-[#CD6700] text-center rounded-lg px-10 py-1 h-full flex items-center">
                                    Extra
                                </span>



                            </div>
                        </td>

                    </tr>
                </tbody>

            </table>
        </div>

    </div>
    <div *ngIf="isSelectAssign">

        <div class="[@container_daily-target_(max-width:48rem)]:flex-wrap flex flex-nowrap items-center justify-between gap-4">

            <div class="flex flex-col justify-between flex-[1_1_12rem] min-w-0 whitespace-normal break-words">
                <p class="font-semibold text-lg mb-1">Centre Target on {{ assignDate | date:'yyyy/MM/dd' }} </p>
            </div>

            <div class="[@container_daily-target_(max-width:48rem)]:flex-wrap [@container_daily-target_(max-width:48rem)]:justify-start [@container_daily-target_(max-width:48rem)]:basis-full [@container_daily-target_(max-width:30rem)]:[&>div]:w-full [@container_daily-target_(max-width:30rem)]:[&>div]:max-w-full [@container_daily-target_(max-width:30rem)]:[&>div]:flex-none [@container_daily-target_(max-width:30rem)]:[&>div]:mr-0 flex flex-nowrap items-center justify-end gap-4 flex-[3_1_auto] min-w-0">

                <p class="text-[#4A4A4A] dark:text-white shrink-0 whitespace-nowrap">Collection Date: </p>

                <div class="w-36 max-w-full shrink-0">
                    <app-custom-datepicker [placeholder]="'Target Date'" [selectedDate]="assignDate"
                        [showClearButton]="true" (dateChange)="onAssignDateChange($event)"></app-custom-datepicker>
                </div>

                <div class="relative w-40 max-w-full shrink-0 custom-assign-status-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectAssignStatus" class="hidden" (change)="filterAssignStatus()">

                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Updated">Updated</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Assigned">Assigned</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Not Assigned">Not Assigned</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleAssignStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                            <span>{{ selectAssignStatus || 'Assign Status' }}</span>
                            <div class="flex items-center">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectAssignStatus" (click)="cancelAssignStatus($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isAssignStatusDropdownOpen || !selectAssignStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isAssignStatusDropdownOpen"
                                    [class.fa-angle-up]="isAssignStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isAssignStatusDropdownOpen"
                        class="absolute overflow-hidden z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div class="">
                            <div *ngFor="let option of assignStatusDropdownOptions; let i = index"
                                (click)="selectAssignStatusOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === assignStatusDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="[@container_daily-target_(max-width:48rem)]:basis-48 [@container_daily-target_(max-width:48rem)]:min-w-48 [@container_daily-target_(max-width:48rem)]:mr-0 flex items-center rounded-full px-4 mr-5 py-2 w-96 max-w-96 min-w-0 flex-[1_1_10rem] bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop / Variety Name" [(ngModel)]="assignSearch"
                        title="Search by Crop / Variety Name"
                        (input)="checkLeadingSpaceAssignSearch()" (keyup.enter)="assignOnSearch()"
                        (keyup.esc)="assignOffSearch()"
                        class="bg-transparent outline-none flex-1 min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="assignOnSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="assignOffSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>



        </div>

        <div *ngIf="showAssignWaitingState"
            class="flex items-center gap-2 mt-8 mr-5 px-4 py-3 rounded-lg bg-[#EDF5FC] text-sm font-[400] text-[#000000] dark:text-gray-800">
            <i class="fa-solid fa-circle-info text-[#415CFF]"></i>
            <p>The target will appear in the system on {{ assignBannerDateLabel }} after 7.00 PM once the CCH officer
                assigns the target.
            </p>
        </div>


        <div *ngIf="showAssignWaitingState"
            class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <div #lottieContainer class="w-40 h-40"></div>
            <p class="text-[#494949] my-6 dark:text-textDark">--No Target Available--</p>
        </div>

        <div *ngIf="showAssignNoDataState"
            class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="!isBeforeAssignDeadline && assignHasData"
            class="overflow-x-auto mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
            <table class="[@container_daily-target_(max-width:48rem)]:min-w-max w-full divide-y-2 overflow-hidden">
                <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class="px-6 py-3 text-left font-medium">No</th>
                        <th class="px-6 py-3 text-left font-medium">Crop Name</th>
                        <th class="px-6 py-3 text-left font-medium">Variety Name</th>
                        <th class="px-6 py-3 text-left font-medium">Target (A)</th>
                        <th class="px-6 py-3 text-left font-medium">Target (B)</th>
                        <th class="px-6 py-3 text-left font-medium">Target (C)</th>
                        <!-- <th class="px-6 py-3 text-left font-medium">Ends At</th> -->
                        <th class="px-6 py-3 text-center font-medium">Assign</th>
                        <th class="px-6 py-3 text-left font-medium"></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <tr *ngFor="let item of assignTargetArr; let i = index" class="border-b">

                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                            {{ (i + 1) < 10 ? ('0' + (i + 1)) : (i + 1) }} </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.cropNameEnglish }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.varietyNameEnglish }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.qtyA }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.qtyB }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.qtyC }}
                        </td>


                        <td class="px-6 py-4 text-center text-black-900 dark:text-gray-300">
                            <span
                                *ngIf="item.isAssign === 0 && (item.assignStatusA === 0 && item.assignStatusB === 0 && item.assignStatusC === 0)">
                                <i class="fa-solid fa-user-plus text-xl"
                                    [class.text-blue-600]="!isAssignDateBeforeToday"
                                    [class.text-gray-400]="isAssignDateBeforeToday"
                                    [class.cursor-pointer]="!isAssignDateBeforeToday"
                                    [class.cursor-not-allowed]="isAssignDateBeforeToday"
                                    (click)="!isAssignDateBeforeToday && navigateToAssignTarget(item.varietyId, item.companyCenterId, item.passingDate)">
                                </i>
                            </span>

                            <span
                                *ngIf="item.isAssign === 1 && (item.assignStatusA === 1 && item.assignStatusB === 1 && item.assignStatusC === 1)">
                                <i class="fa-solid fa-pen-to-square text-xl"
                                    [class.text-blue-600]="!isAssignDateBeforeToday"
                                    [class.text-gray-400]="isAssignDateBeforeToday"
                                    [class.cursor-pointer]="!isAssignDateBeforeToday"
                                    [class.cursor-not-allowed]="isAssignDateBeforeToday"
                                    (click)="!isAssignDateBeforeToday && navigateToEditAssignTarget(item.varietyId, item.companyCenterId, item.passingDate)">
                                </i>
                            </span>

                            <span
                                *ngIf="item.isAssign === 1 && (item.assignStatusA === 0 || item.assignStatusB === 0 || item.assignStatusC === 0)">
                                <i class="fa-solid fa-pen-to-square text-xl"
                                    [class.text-red-600]="!isAssignDateBeforeToday"
                                    [class.text-gray-400]="isAssignDateBeforeToday"
                                    [class.cursor-pointer]="!isAssignDateBeforeToday"
                                    [class.cursor-not-allowed]="isAssignDateBeforeToday"
                                    (click)="!isAssignDateBeforeToday && navigateToEditAssignTarget(item.varietyId, item.companyCenterId, item.passingDate)">
                                </i>
                            </span>
                        </td>

                        <td>
                            <i class="fa-solid fa-circle-check text-2xl"
                                [class.text-blue-600]="!isAssignDateBeforeToday"
                                [class.text-gray-400]="isAssignDateBeforeToday"
                                *ngIf="item.isAssign === 1 && (item.assignStatusA === 1 && item.assignStatusB === 1 && item.assignStatusC === 1)">
                            </i>

                            <i class="fa-solid fa-circle-check text-2xl"
                                [ngClass]="isAssignDateBeforeToday ? 'text-gray-400' : 'text-[#EB3223]'"
                                *ngIf="item.isAssign === 1 && (item.assignStatusA === 0 || item.assignStatusB === 0 || item.assignStatusC === 0)">
                            </i>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>

</div>
